import { useState } from 'react'

export function useSearchAreaDialogs() {
  const [searchDialogOpen, setSearchDialogOpen] = useState(false)
  const [createDialogOpen, setCreateDialogOpen] = useState(false)

  return {
    searchDialogOpen,
    setSearchDialogOpen,
    createDialogOpen,
    setCreateDialogOpen,
  }
}
